import {
  FormMultiSelector,
  TooltipTrigger,
  TooltipContent,
  Typography,
  Tooltip,
  Button,
} from '@ui/components';
import { RequestFieldFilterType } from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { Delete } from '@ui/components/icons';
import { Control } from 'react-hook-form';
import { cn } from '@ui/utils';
import React from 'react';
interface VehiclesTableForm {
  [RequestFieldFilterType.VEHICLE_SERVICE]: string[];
  [RequestFieldFilterType.VEHICLE_REGISTRATION_COUNTRY]: string[];
  [RequestFieldFilterType.VEHICLE_CATEGORY]: string[];
}

interface VehiclesTableFiltersProps extends React.ComponentPropsWithoutRef<'div'> {
  controls: Control<VehiclesTableForm>;
  reset: () => void;
  isLoading?: boolean;
  options: {
    countryCodes: { label: string; value: string }[];
    categories: { label: string; value: string }[];
    services: { label: string; value: string }[];
  };
}

export function VehiclesTableFilters({
  className,
  isLoading,
  controls,
  options,
  reset,
}: VehiclesTableFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex gap-4 justify-between', className)}>
      <div className="flex gap-4 flex-wrap">
        <FormMultiSelector
          placeholder={t('VEHICLES.TABLE_HEADER_SERVICES')}
          name={RequestFieldFilterType.VEHICLE_SERVICE}
          className="min-w-50 w-71 flex-1"
          options={options.services}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
        <FormMultiSelector
          name={RequestFieldFilterType.VEHICLE_REGISTRATION_COUNTRY}
          placeholder={t('VEHICLES.TABLE_HEADER_COUNTRY_CODE')}
          className="min-w-50 w-71 flex-1"
          options={options.countryCodes}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
        <FormMultiSelector
          placeholder={t('VEHICLES.TABLE_HEADER_CATEGORY')}
          name={RequestFieldFilterType.VEHICLE_CATEGORY}
          className="min-w-50 w-71 flex-1"
          options={options.categories}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button onClick={reset} variant="ghost" icon>
            <Delete />
          </Button>
        </TooltipTrigger>

        <TooltipContent className="w-auto">
          <Typography variant="labelXSmallBook">
            {t('VEHICLES.TABLE_HEADER_CLEAR_FILTERS')}
          </Typography>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
